module.exports = __webpack_public_path__ + "static/media/customer.6184be31.png";